import { ApiBaseClass, OurUseQueryOptions } from "@nens/react-query-utils";

class LdoApiV1 extends ApiBaseClass {
  tenantId: number;

  constructor(baseUrl: string, authToken: string | undefined, tenantId: number) {
    super(baseUrl, authToken);
    this.tenantId = tenantId;
  }

  setTenantAndAuthToken(tenantId: number, authToken: string | undefined) {
    this.tenantId = tenantId;
    this.setAuthToken(authToken);
  }

  getQueryOptions<T>(queryOptions: OurUseQueryOptions<T>): OurUseQueryOptions<T> {
    const key = queryOptions.queryKey ?? [];
    return {
      ...queryOptions,
      queryKey: ["ldo-api-v1", this.tenantId, ...key],
    };
  }
}

export const ldoApiV1 = new LdoApiV1("/api/v1", undefined, 0);
